/** @jsxImportSource @emotion/react */
import { COLORS } from '@btime/constants'
import { css } from '@emotion/react'
import React from 'react'

import { CompanyAvatar, UserAvatar } from './Avatar'
import { Title } from './Text'
import Container from '../structure/Container'
import FlexGrid, { FlexColumn } from '../structure/FlexGrid'
import Panel, { PanelContent } from '../structure/Panel'
import Separator from '../helpers/Separator'
import Text from '../../packages/kiti/components/presentation/Text'
import breakpoints from '../../utils/constants/breakpoints'

const HeaderPanelFooter = ({ children, absolute }) => {
  if (!children) return false
  if (!absolute) return children
  const style = css`
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;

    @media (max-width: ${breakpoints.md}px) {
      position: static;
    }
  `

  return <div css={style}>{children}</div>
}

const HeaderPanel = props => {
  let { absoluteFooter, bgColor, bgImage, title, subtitle, footer, side, avatar, squareAvatar, ...restProps } = props

  const style = css`
    position: relative;
  `

  bgColor = bgColor || COLORS.purple
  const avatarProps = { size: 'medium', borderColor: COLORS.white }

  return (
    <Panel bgColor={bgColor} bgImage={bgImage} noPadding {...restProps}>
      <Container>
        <div css={style}>
          <PanelContent>
            <Separator weight={4} />
            <FlexGrid gutter={0.5}>
              {avatar && (
                <FlexColumn>
                  {squareAvatar ? (
                    <CompanyAvatar company={avatar} {...avatarProps} />
                  ) : (
                    <UserAvatar user={avatar} {...avatarProps} />
                  )}
                </FlexColumn>
              )}
              <FlexColumn flex={1}>
                <Title size="h2" color={COLORS.white} noMargin>
                  {title}
                </Title>
                {!!subtitle && (
                  <Text color="light5" bold>
                    {subtitle}
                  </Text>
                )}
              </FlexColumn>
              <FlexColumn>{side}</FlexColumn>
            </FlexGrid>
            <Separator weight={7} />
          </PanelContent>

          <HeaderPanelFooter absolute={absoluteFooter}>{footer}</HeaderPanelFooter>
        </div>
      </Container>
    </Panel>
  )
}

export default HeaderPanel
